import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Modal, ModalBody, ModalHeader, Col, Label, Input, Row } from 'reactstrap';
import Select from 'react-select';
import { UPDATE_BINS } from '../../../../../../../store/application/actionType';
import { AsyncPaginate } from 'react-select-async-paginate';
import { baseUrl, customHeaders } from '../../../../../../Config';
import { Constant } from '../../../../../../Helpers/constant';
import axios from 'axios';

const UpdateBinModal = ({ data, selectedProject, onCloseHandler }) => {
  const dispatch = useDispatch();

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const initialObj = {
    number: '',
    name: '',
    description: '',
    gateways: [],
    projectCode: '',
    benefitGroupId: null,
    binId: '',
    isActive: false,
  };
  const [state, setState] = useState(initialObj);

  const [isValidationShow, setIsValidationShow] = useState(false);
  const [isSubmitBtnDisabled, setIsSubmitBtnDisabled] = useState(true);
  const [allPaymentGatways, setAllPaymentGateways] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (data !== null) {
      setState({
        gateways: data?.pgCodes?.map(code => {
          return {
            value: code,
            label: selectedProject?.configuration?.payment?.gateways?.find(gateway => gateway?.pgData?.code === code)?.pgData?.name,
          };
        }),
        benefitGroupId: data?.benefitGroupId
          ? {
              value: data?.benefitGroupId || data?.benefitGroupId,
              label: data?.benefitGroupName || 'Loading...', // fallback if name not present
            }
          : '',
        binId: data?.binId,
        projectCode: selectedProject?.code,
        number: data?.number,
        name: data?.name,
        description: data?.description,
        isActive: data?.isActive ? true : false,
      });
    }
  }, []);

  useEffect(() => {
    if (selectedProject !== null) {
      setAllPaymentGateways(
        selectedProject?.configuration?.payment?.gateways?.map(gateway => {
          return {
            value: `${gateway?.pgData?.objectId}`,
            label: `${gateway?.pgData?.name}`,
            code: `${gateway?.pgData?.code}`,
            status: `${gateway?.status}`,
            logo: `${gateway?.pgData?.logo}`,
          };
        }),
      );
    }
  }, [selectedProject]);

  /* ---------------------------- INPUT CHANGE HANDLER ---------------------------- */
  const inputChangeHandler = e => {
    const { name, value } = e.target;
    let updatedState = null;

    switch (name) {
      case 'name':
        if (value.length <= 30) {
          updatedState = {
            ...state,
            name: value,
          };
          setState(updatedState);
          validationCheck(updatedState);
        }
        break;

      case 'number':
        if (value.length <= 8) {
          updatedState = {
            ...state,
            number: value,
          };
          setState(updatedState);
          validationCheck(updatedState);
        }
        break;

      case 'description':
        if (value.length <= 100) {
          updatedState = {
            ...state,
            description: value,
          };
          setState(updatedState);
          validationCheck(updatedState);
        }
        break;

      case 'isActive':
        updatedState = {
          ...state,
          isActive: !state.isActive,
        };
        setState(updatedState);
        validationCheck(updatedState);
        break;

      default:
      // do nothing
    }
  };

  const inputSelectHandler = (label, data) => {
    let updatedState = { ...state };

    if (label === `gateways`) {
      updatedState = {
        ...state,
        gateways: data,
      };
    } else if (label === `benefitGroupId`) {
      updatedState = {
        ...state,
        benefitGroupId: data,
      };
    }

    setState(updatedState);
    validationCheck(updatedState);
  };

  /* ---------------------------- VALIDATION CHECK ---------------------------- */
  const validationCheck = data => {
    const newErrors = {};

    if (!data?.name?.trim()) newErrors.name = 'Name is required';
    if (!data?.description?.trim()) newErrors.description = 'Description is required';
    if (!data?.benefitGroupId) newErrors.benefitGroupId = 'Benefit group is required';
    if (!data?.gateways || data?.gateways.length === 0) newErrors.gateways = 'At least one payment gateway is required';

    setErrors(newErrors);
    setIsSubmitBtnDisabled(Object.keys(newErrors).length > 0);
  };

  /* ---------------------------- SUBMIT HANDLER ---------------------------- */
  const submitHandler = () => {
    validationCheck(state); // ensure latest errors before submitting

    if (Object.keys(errors).length > 0) {
      setIsValidationShow(true);
      return;
    }

    const { isActive, number, ...restState } = state;

    const payload = {
      ...restState,
      benefitGroupId: state?.benefitGroupId?.value,
      ...(isActive !== data?.isActive && { isActive }),
      gateways: state?.gateways?.map(gateway => gateway?.code),
    };

    dispatch({
      type: UPDATE_BINS,
      payload: {
        data: payload,
      },
    });

    onCloseHandler(false);
  };

  const tog_varying1 = () => {
    onCloseHandler(false);
  };

  const loadOptionForBenefitGroup = async search => {
    return await axios({
      method: `GET`,
      url: `${baseUrl}/admin/benefitGroups`,
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        name: search === '' ? null : search,
      },
    })
      .then(function (response) {
        return {
          options: response?.data?.results?.map(data => {
            return {
              value: data?.objectId,
              label: `${data?.name}`,
              completeData: data,
            };
          }),
          hasMore: false,
        };
      })
      .catch(err => {
        return err;
      });
  };

  return (
    <Modal isOpen={true}>
      <div className="modal-header p-3 bg-soft-secondary">
        <h5 className="modal-title">Update Bin</h5>
        <Button type="button" onClick={() => tog_varying1()} id="addBoardBtn-close" className="btn-close btn-light" aria-label="Close"></Button>
      </div>
      <ModalBody>
        {/* <button onClick={() => console.log(data)}>Get state</button> */}
        <form>
          <Row>
            <div className="mb-3">
              <Col md={12}>
                <div>
                  <Label htmlFor="name" className="form-label">
                    Name <span className="lbl_mandatory">*</span>
                  </Label>
                  <Input id="name" name="name" value={state?.name} className="form-control" onChange={inputChangeHandler} />
                  {isValidationShow && errors.name && <span className="text-danger">{errors.name}</span>}
                </div>
              </Col>
            </div>

            <div className="mb-3">
              <Col md={12}>
                <div>
                  <Label htmlFor="name" className="form-label">
                    Number
                  </Label>
                  <Input
                    id="number"
                    name="number"
                    value={state?.number}
                    className="form-control"
                    disabled={true}
                    // onChange={inputChangeHandler}
                  />
                </div>
              </Col>
            </div>

            <div className="mb-3">
              <Col md={12}>
                <div>
                  <Label htmlFor="name" className="form-label">
                    Description <span className="lbl_mandatory">*</span>
                  </Label>
                  <Input id="description" name="description" value={state?.description} className="form-control" onChange={inputChangeHandler} />
                  {isValidationShow && errors.description && <span className="text-danger">{errors.description}</span>}
                </div>
              </Col>
            </div>

            <div className="mb-3">
              <Col md={12}>
                <div>
                  <Label htmlFor="benefit-group" className="form-label">
                    Benefit Group <span className="lbl_mandatory">*</span>
                  </Label>
                  <AsyncPaginate
                    debounceTimeout={500}
                    value={state?.benefitGroupId}
                    loadOptions={loadOptionForBenefitGroup}
                    onChange={data => inputSelectHandler(`benefitGroupId`, data)}
                    isMulti={false}
                    closeMenuOnSelect={true}
                    noOptionsMessage={() => 'No results found'}
                    cacheUniqs={[['code']]}
                    placeholder="Select Benefit Group"
                    // isDisabled={props?.currentSelectedDetails}
                  />
                  {isValidationShow && errors.benefitGroupId && <span className="text-danger">{errors.benefitGroupId}</span>}
                </div>
              </Col>
            </div>

            <div className="mb-3">
              <Col md={12}>
                <div>
                  <Label htmlFor="name" className="form-label">
                    Payment Gateway <span className="lbl_mandatory">*</span>
                  </Label>
                  <Select
                    id="gateways"
                    name="gateways"
                    isMulti={true}
                    value={state?.gateways}
                    options={allPaymentGatways}
                    onChange={data => inputSelectHandler(`gateways`, data)}
                  />
                  {isValidationShow && errors.gateways && <span className="text-danger">{errors.gateways}</span>}
                </div>
              </Col>
            </div>

            <div className="mb-3">
              <Label htmlFor="membershipGenerationRestriction" className="form-label">
                isActive
              </Label>
              <div className="d-flex align-items-center ">
                <span className="text-muted">False &nbsp;</span>
                <div className="form-switch d-inline-block ">
                  <Input
                    className="form-check-input code-switcher form-switch-md cursor-pointer"
                    type="checkbox"
                    id="isActive"
                    name="isActive"
                    checked={state?.isActive}
                    onChange={inputChangeHandler}
                  />
                </div>
                <span> &nbsp;True</span>
              </div>
            </div>
          </Row>
        </form>
      </ModalBody>

      <div className="modal-footer d-flex justify-content-center">
        <Button className="overlay-disable" color="primary" onClick={submitHandler}>
          Submit
        </Button>
      </div>
    </Modal>
  );
};

export default UpdateBinModal;
